<template>
    <div class="grid">
        <loading :active="isLoadingModel" :can-cancel="true" color="#173EA3" :is-full-page="fullPage"></loading>
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="my-2">
                            <span class="p-float-label">
                                <Dropdown style="width:150px" id="state" v-model="district_id_search" filter
                                    :options="district_dropdown" optionLabel="name" :optionValue="value">
                                </Dropdown>
                                <label>District</label>
                            </span>
                        </div>&nbsp;
                        <div class="my-2">
                            <span class="p-float-label">
                                <Dropdown style="width:150px" id="state" v-model="taluka_id_search" filter
                                    :options="taluka_dropdown" optionLabel="name" :optionValue="value">
                                </Dropdown>
                                <label>Taluka</label>
                            </span>
                        </div>&nbsp;
                        <div class="my-2">
                            <span class="p-float-label">
                                <Dropdown style="width:150px" id="state" v-model="village_id_search" filter
                                    :options="village_dropdown" optionLabel="name" :optionValue="value">
                                </Dropdown>
                                <label>Village</label>
                            </span>
                        </div>&nbsp;
                        <div class="my-2">
                            <span class="p-float-label">
                                <Dropdown style="width:150px" id="state" v-model="block_id_search" filter
                                    :options="block_dropdown" optionLabel="name" :optionValue="value">
                                </Dropdown>
                                <label>Block</label>
                            </span>
                        </div>&nbsp;
                        <!--<div class="my-2">
                <span class="p-float-label">
                  <Dropdown v-if="user_key && (user_key=='Admin' || user_key=='admin')" style="width:150px" id="state" filter  v-model="client_id_search" :options="client_id_dropdown" optionLabel="name" :optionValue="code" ></Dropdown>
                  <label>Select Client</label>
                </span>
                </div>&nbsp; -->
                        <div class="my-2">
                            <Button icon="pi pi-search" v-tooltip.bottom="'Search'" />
                            <!-- <Button
                  label="Delete"
                  icon="pi pi-trash"
                  class="p-button-danger"
                  @click="confirmDeleteSelected"
                  :disabled="!selectedProducts || !selectedProducts.length"
                /> -->
                            <!-- &nbsp;
                <Button
                  icon="pi pi-sync"
                  class="p-button-info mr-2"
                  @click="get_list"
                /> -->
                        </div>
                    </template>
                    <template v-slot:end>
                        <!-- <Button
                  icon="pi pi-plus"
                  v-tooltip.bottom="'Add'"
                  @click="openNew"
                /> -->
                        <!-- <FileUpload
                mode="basic"
                accept="image/*"
                :maxFileSize="1000000"
                label="Import"
                chooseLabel="Import"
                class="mr-2 inline-block"
              /> -->
                        <json-excel :data="product">
                            <Button label="Export" icon="pi pi-upload" class="p-button-help" @click="exportCSV" />
                        </json-excel>
                    </template>
                </Toolbar>
                <!-- {{ products }} -->
                <DataTable :loading="loading" ref="dt" :lazy="true" :totalRecords="totalRecords" :paginator="true"
                    :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit"
                    :filters="filters" @page="onPage($event)"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25, totalRecords]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
                    style="font-size: 12px" :rowHover="true" showGridlines>
                    <template #empty>
                        <b style="text-align:center">No records found.</b>
                    </template>
                    <template #header>
                        <div class="
                  flex flex-column
                  md:flex-row md:justify-content-between md:align-items-center
                ">
                            <h5 class="m-0"><b>SBM REPORT</b></h5>
                            <!-- Total Records:{{totalRecords}} -->
                            <Button icon="pi pi-refresh" v-tooltip.bottom="'Refresh'" />
                        </div>
                        <div style="text-align:right;font-weight:bold"><span>Total Records:</span>{{ totalRecords }}</div>
                    </template>
                    <Column header="Sr No" style="min-width: 5rem;text-align: center;">
                        <template #body="{ index }">
                            <span v-if="page_no == 1">{{ +index + +1 }}</span>
                            <span v-else>{{ (+index + 1) + limit * (page_no - 1) }}</span>
                        </template>
                    </Column>
                    <Column header="District" :field="columns[0]" style="text-align:left;">
                        <template #body="{ data }">
                            {{ data.District }}
                        </template>
                    </Column>
                    <Column header="Taluka" style="min-width: 5rem" :field="columns[1]">
                        <template #body="{ data }">
                            {{ data.Taluka }}
                        </template>
                    </Column>
                    <!-- <Column header="RC Number" :field="columns[3]" style="min-width: 5rem">
              <template #body="{ data }">
                {{ data.rc_number }}
              </template>
            </Column>
            <Column header="PUC Validity" :field="columns[10]">
              <template #body="{ data }">
                {{ dateFormat(data.puc_validity) }}
              </template>
            </Column>
            <Column header="Insurance Validity" :field="columns[10]">
              <template #body="{ data }">
                {{ dateFormat(data.insurance_validity) }}
              </template>
            </Column> -->
                    <Column header="Village" :field="columns[2]">
                        <template #body="{ data }">
                            {{ data.Village }}
                        </template>
                    </Column>
                    <Column header="Block" :field="columns[3]">
                        <template #body="{ data }">
                            {{ data.Block }}
                        </template>
                    </Column>
                    <Column header="Total Homes" :field="columns[4]" style="text-align:right;">
                        <template #body="{ data }">
                            {{ data.Total_Homes }}
                        </template>
                    </Column>
                    <Column header="Visited Homes" :field="columns[5]" style="text-align:right;">
                        <template #body="{ data }">
                            {{ data.Visited_Homes }}
                        </template>
                    </Column>
                    <!-- <Column header="Action" headerStyle="min-width:15rem;">
              <template #body="slotProps">
                <Button
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-success mr-2"
                    v-tooltip.bottom="'View'"
                    @click="viewProduct(slotProps.data)"
                  />
                <Button
                  icon="pi pi-pencil"
                  v-tooltip.bottom="'Edit'"
                  class="p-button-rounded p-button-primary mr-2"
                  @click="editProduct(slotProps.data)"
                />
                <Button
                  icon="pi pi-trash"
                  v-tooltip.bottom="'Delete'"
                  class="p-button-rounded p-button-warning mr-2"
                  @click="confirmDeleteProduct(slotProps.data)"
                />
              </template>
            </Column> -->
                </DataTable>
                <Sidebar v-model:visible="productDialog" :baseZIndex="1000" position="full">
                    <div class="col-12">
                        <div class="card">
                            <h5>User Form</h5>
                            <hr />
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-2">
                                    <label for="status">Status</label>
                                    <Dropdown id="status" v-model="selectstatus" :options="dropdownItems"
                                        :value="dropdownItems.value" optionLabel="name" placeholder="Select One"
                                        :class="{ 'p-invalid': submitted && !selectstatus }" required="true"></Dropdown>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="firsT_NAME">First Name</label>
                                    <InputText id="firsT_NAME" type="text" v-model.trim="product.firsT_NAME" required="true"
                                        autofocus :class="{ 'p-invalid': submitted && !product.firsT_NAME }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="middeL_NAME">Middle Name</label>
                                    <InputText id="middeL_NAME" type="text" v-model.trim="product.middeL_NAME"
                                        required="true" autofocus
                                        :class="{ 'p-invalid': submitted && !product.middeL_NAME }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="surname">Lastname</label>
                                    <InputText id="surname" type="text" v-model.trim="product.surname" required="true"
                                        autofocus :class="{ 'p-invalid': submitted && !product.surname }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="aadhaR_CARD">Adhar No</label>
                                    <InputText id="aadhaR_CARD" type="number" v-model.trim="product.aadhaR_CARD"
                                        required="true" autofocus
                                        :class="{ 'p-invalid': submitted && !product.aadhaR_CARD }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="state">State</label>
                                    <InputText id="state" type="text" v-model.trim="product.state" required="true" autofocus
                                        :class="{ 'p-invalid': submitted && !product.state }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="disrtict">District</label>
                                    <InputText id="disrtict" type="text" v-model.trim="product.disrtict" required="true"
                                        autofocus :class="{ 'p-invalid': submitted && !product.disrtict }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="taluka">Taluka</label>
                                    <InputText id="taluka" type="text" v-model.trim="product.taluka" required="true"
                                        autofocus :class="{ 'p-invalid': submitted && !product.taluka }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="citY_VILLAGE">City/Village</label>
                                    <InputText id="citY_VILLAGE" type="text" v-model.trim="product.citY_VILLAGE"
                                        required="true" autofocus
                                        :class="{ 'p-invalid': submitted && !product.citY_VILLAGE }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="pincode">Pincode</label>
                                    <InputText id="pincode" type="number" v-model.trim="product.pincode" required="true"
                                        autofocus :class="{ 'p-invalid': submitted && !product.pincode }" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card">
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12">
                                    <label for="address">Address</label>
                                    <Textarea id="address" type="text" v-model.trim="product.address" required="true"
                                        autofocus :class="{ 'p-invalid': submitted && !product.address }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="mobile">Mobile No</label>
                                    <InputText id="mobile" type="number" v-model.trim="product.mobile" required="true"
                                        autofocus :class="{
                                            'p-invalid': submitted && !product.mobile,
                                        }" />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="email">Email</label>
                                    <InputText id="email" type="text" v-model.trim="product.email" required="true" autofocus
                                        :class="{ 'p-invalid': submitted && !product.email }" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <Button v-if="product.admiN_ID" label="UPDATE" icon="pi pi-check" class="p-button-success mr-1 mb-1"
                            @click="adduser" />
                        <Button v-else label="ADD" icon="pi pi-check" class="p-button-success mr-1 mb-1" @click="adduser" />
                        <Button label="Cancel" icon="pi pi-times" class="p-button-danger mr-1 mb-1"
                            @click="visibleFull = false" />
                    </div>
                </Sidebar>
                <Dialog v-model:visible="productDialog_old" :style="{ width: '450px', width: '450px' }"
                    header="Year Details" :modal="true" class="p-fluid">
                    <div class="grid">
                        <div class="col-12 md:col-12">
                            <div class="field">
                                <!-- <img
              :src="'images/product/shoes.jpg'"
              :alt="product.image"
              width="150"
              class="mt-0 mx-auto mb-5 block shadow-2"
            /> -->
                            </div>
                            <div class="field">
                                <label for="enrollmenT_YEAR">Enrollement Year <i style="color: green">(eg.2022)</i></label>
                                <InputText id="enrollmenT_YEAR" v-model.trim="product.enrollmenT_YEAR" required="true"
                                    autofocus :class="{
                                        'p-invalid': submitted && !product.enrollmenT_YEAR,
                                    }" />
                            </div>
                            <div class="field">
                                <label for="exaM_YEAR">Exam Year <i style="color: green">(eg.2022-23)</i></label>
                                <InputText id="exaM_YEAR" v-model.trim="product.exaM_YEAR" required="true" autofocus
                                    :class="{ 'p-invalid': submitted && !product.exaM_YEAR }" />
                                <!-- <small class="p-invalid" v-if="submitted && !product.name"
                    >Name is required.</small
                  > -->
                            </div>
                            <!-- <div class="field">
                  <label for="description">Description</label>
                  <Textarea
                    id="description"
                    v-model.trim="product.description"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.description }"
                  />
                </div>
                <div class="field">
                  <label for="link">Video Link</label>
                  <InputText
                    id="link"
                    v-model.trim="product.videolink"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.link }"
                  />
                </div>
                <div class="field">
                  <label for="status">Type</label>
                  <Dropdown
                    id="state"
                    v-model="selectstatus"
                    :options="dropdownItems"
                    :value="dropdownItems.value"
                    optionLabel="name"
                    placeholder="Select One"
                    :class="{ 'p-invalid': submitted && !selectstatus }"
                    required="true"
                  ></Dropdown>
                </div>
                <div class="field">
                  <label for="status">Status</label>
                  <Dropdown
                    id="state"
                    v-model="selectstatus2"
                    :options="dropdownItems2"
                    :value="dropdownItems2.value"
                    optionLabel="name"
                    placeholder="Select One"
                    :class="{ 'p-invalid': submitted && !selectstatus2 }"
                    required="true"
                  ></Dropdown>
                </div> -->
                        </div>
                        <div class="col-12 md:col-6">
                            <!-- <Button
                  v-if="product.mjyeaR_ID"
                  label="UPDATE"
                  icon="pi pi-check"
                  class="p-button-success mr-1 mb-1"
                  @click="Addyear"
                />
                <Button
                  v-else
                  label="ADD"
                  icon="pi pi-check"
                  class="p-button-success mr-1 mb-1"
                  @click="Addyear"
                /> -->
                        </div>
                        <div class="col-12 md:col-6">
                            <Button label="Cancel" icon="pi pi-times" class="p-button-danger mr-1 mb-1"
                                @click="productDialog = false" />
                        </div>
                    </div>
                </Dialog>
                <Dialog v-model:visible="qrCodetDialog" :style="{ width: '450px' }" header="QR Code" :modal="true">
                    <div style="text-align:right">
                        <Button icon="pi pi-print" @click="printQr()" class="p-button-rounded p-button-info mr-2 mb-2" />
                        <Button icon="pi pi-download" @click="downloadQr()"
                            class="p-button-rounded p-button-info mr-2 mb-2" />
                    </div>
                    <br>
                    <div>
                        <qrcode-vue id="qrprint" type="image/png" style="width:100%" :value="qrcodevalue" size="450"
                            level="H" />
                    </div>
                </Dialog>
                <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span v-if="product">Are you sure you want to delete <b>{{ product.firsT_NAME }}</b>?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
                        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteuser" />
                    </template>
                </Dialog>
                <Dialog v-model:visible="deleteProductsDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span v-if="product">Are you sure you want to delete the selected products?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductsDialog = false" />
                        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedProducts" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import QrcodeVue from 'qrcode.vue'
//import FormNewsMaster from "@/components/FormNewsMaster";
//import * as Survey from "survey-vue";
// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
export default {
    data() {
        return {
            client_id_dropdown: [],
            client_id_search: '',
            reg_number: '',
            page_no: 1,
            qrcodevalue: "123444",
            isLoading: false,
            isLoadingModel: false,
            loading: false,
            fullPage: true,
            qrCodetDialog: false,
            file_attachment: "",
            // dropdownItems: [
            //   { name: "Motivational", value: "Motivational" },
            //   { name: "Interview", value: "Interview" },
            // ],
            dropdownItems: [
                { name: "Active", value: "Active" },
                { name: "InActive", value: "InActive" },
                { name: "Deleted", value: "Deleted" },
            ],
            products: [
                { District: 'Jalgaon', Taluka: 'Chopda', Village: 'Ambadgaon', Block: 'Block1', Total_Homes: '125', Visited_Homes: '75' },
                { District: 'Ahmednagar', Taluka: 'Shevgaon', Village: 'Adgaon', Block: 'Block2', Total_Homes: '250', Visited_Homes: '21' },
                { District: 'Ratnagiri', Taluka: 'Lanja', Village: 'Bhatye', Block: 'Block3', Total_Homes: '358', Visited_Homes: '99' },
                { District: 'Jalgaon', Taluka: 'Chopda', Village: 'Bhalod', Block: 'Block1', Total_Homes: '125', Visited_Homes: '75' },
                { District: 'Ahmednagar', Taluka: 'Shevgaon', Village: 'Bhalgaon', Block: 'Block2', Total_Homes: '250', Visited_Homes: '21' },
                { District: 'Ratnagiri', Taluka: 'Lanja', Village: 'Dabhol', Block: 'Block3', Total_Homes: '358', Visited_Homes: '99' },
                { District: 'Jalgaon', Taluka: 'Chopda', Village: 'Chichondi', Block: 'Block1', Total_Homes: '125', Visited_Homes: '75' },
                { District: 'Ahmednagar', Taluka: 'Shevgaon', Village: 'Dighol', Block: 'Block2', Total_Homes: '250', Visited_Homes: '21' },
                { District: 'Ratnagiri', Taluka: 'Lanja', Village: 'Gane', Block: 'Block3', Total_Homes: '358', Visited_Homes: '99' },
                { District: 'Jalgaon', Taluka: 'Chopda', Village: 'Dhamangaon', Block: 'Block1', Total_Homes: '125', Visited_Homes: '75' },
            ],
            block_dropdown: [
                { name: 'Block1', value: 'Block1' },
                { name: 'Block2', value: 'Block2' },
                { name: 'Block3', value: 'Block3' },
                { name: 'Block4', value: 'Block4' },
                { name: 'Block5', value: 'Block5' },
            ],
            village_dropdown: [
                { name: 'Panvel', value: 'Panvel' },
                { name: 'Swawood', value: 'Swawood' },
                { name: 'khandeshwar', value: 'khandeshwar' },
                { name: 'Mansarovar', value: 'Mansarovar' },
                { name: 'Nerul', value: 'Nerul' },
                { name: 'Sanpada', value: 'Sanpada' },
                { name: 'Vashi', value: 'Vashi' },
                { name: 'Mankhurd', value: 'Mankhurd' },
                { name: 'Turbhe', value: 'Turbhe' },
                { name: 'Ghansoli', value: 'Ghansoli' },
                { name: 'Palghar', value: 'Palghar' },
                { name: 'Diva', value: 'Diva' },
                { name: 'Vasai', value: 'Vasai' },
                { name: 'karjat', value: 'karjat' },
                { name: 'kasara', value: 'kasara' },
            ],
            taluka_dropdown: [
                { name: 'Ahmednagar', value: 'Ahmednagar' },
                { name: 'Akole', value: 'Akole' },
                { name: 'Jamkhed', value: 'Jamkhed' },
                { name: 'Karjat', value: 'Karjat' },
                { name: 'Kopargaon', value: 'Kopargaon' },
                { name: 'Nagar', value: 'Nagar' },
                { name: 'Nevasa', value: 'Nevasa' },
                { name: 'Parner', value: 'Parner' },
                { name: 'Pathardi', value: 'Pathardi' },
                { name: 'Rahata', value: 'Rahata' },
                { name: 'Sangamner', value: 'Sangamner' },
                { name: 'Shevgaon', value: 'Shevgaon' },
                { name: 'Shrigonda', value: 'Shrigonda' },
                { name: 'Shrirampur', value: 'Shrirampur' },
                { name: 'Akola', value: 'Akola' },
                { name: 'Akot', value: 'Akot' },
                { name: 'Balapur', value: 'Balapur' },
                { name: 'Murtijapur', value: 'Murtijapur' },
                { name: 'Patur', value: 'Patur' },
                { name: 'Telhara', value: 'Telhara' },
                { name: 'Achalpur', value: 'Achalpur' },
                { name: 'Amravati', value: 'Amravati' },
                { name: 'Anjangaon Surji', value: 'Anjangaon Surji' },
                { name: 'Bhatkuli', value: 'Bhatkuli' },
                { name: 'Chandur Railway', value: 'Chandur Railway' },
                { name: 'Chikhaldara', value: 'Chikhaldara' },
                { name: 'Daryapur', value: 'Daryapur' },
                { name: 'Dharni', value: 'Dharni' },
                { name: 'Morshi', value: 'Morshi' },
                { name: 'Nandgaon-Khandeshwar', value: 'Nandgaon-Khandeshwar' },
                { name: 'Teosa', value: 'Teosa' },
                { name: 'Aurangabad', value: 'Aurangabad' },
                { name: 'Gangapur', value: 'Gangapur' },
                { name: 'Kannad', value: 'Kannad' },
                { name: 'Khuldabad', value: 'Khuldabad' },
                { name: 'Paithan', value: 'Paithan' },
                { name: 'Phulambri', value: 'Phulambri' },
                { name: 'Sillod', value: 'Sillod' },
                { name: 'Soegaon', value: 'Soegaon' },
                { name: 'Vaijapur', value: 'Vaijapur' },
                { name: 'Beed', value: 'Beed' },
                { name: 'Dharur', value: 'Dharur' },
                { name: 'Georai', value: 'Georai' },
                { name: 'Kaij', value: 'Kaij' },
                { name: 'Majalgaon', value: 'Majalgaon' },
                { name: 'Parli', value: 'Parli' },
                { name: 'Patoda', value: 'Patoda' }
            ],
            district_dropdown: [
                { name: 'Ahmednagar', value: 'Ahmednagar' },
                { name: 'Akola', value: 'Akola' },
                { name: 'Amravati', value: 'Amravati' },
                { name: 'Aurangabad', value: 'Aurangabad' },
                { name: 'Beed', value: 'Beed' },
                { name: 'Bhandara', value: 'Bhandara' },
                { name: 'Buldhana', value: 'Buldhana' },
                { name: 'Chandrapur', value: 'Chandrapur' },
                { name: 'Dhule', value: 'Dhule' },
                { name: 'Gadchiroli', value: 'Gadchiroli' },
                { name: 'Gondia', value: 'Gondia' },
                { name: 'Hingoli', value: 'Hingoli' },
                { name: 'Jalgaon', value: 'Jalgaon' },
                { name: 'Jalna', value: 'Jalna' },
                { name: 'Kolhapur', value: 'Kolhapur' },
                { name: 'Latur', value: 'Latur' },
                { name: 'Mumbai City', value: 'Mumbai' },
                { name: 'Mumbai Suburban', value: 'Mumbai' },
                { name: 'Nagpur', value: 'Nagpur' },
                { name: 'Nanded', value: 'Nanded' },
                { name: 'Nandurbar', value: 'Nandurbar' },
                { name: 'Nashik', value: 'Nashik' },
                { name: 'Osmanabad', value: 'Osmanabad' },
                { name: 'Palghar', value: 'Palghar' },
                { name: 'Parbhani', value: 'Parbhani' },
                { name: 'Pune', value: 'Pune' },
                { name: 'Raigad', value: 'Raigad' },
                { name: 'Ratnagiri', value: 'Ratnagiri' },
                { name: 'Sangli', value: 'Sangli' },
                { name: 'Satara', value: 'Satara' },
                { name: 'Sindhudurg', value: 'Sindhudurg' },
                { name: 'Solapur', value: 'Solapur' },
                { name: 'Thane', value: 'Thane' },
                { name: 'Wardha', value: 'Wardha' },
                { name: 'Washim', value: 'Washim' },
                { name: 'Yavatmal', value: 'Yavatmal' }
            ],
            district_id_search: '',
            taluka_id_search: '',
            village_id_search: '',
            block_id_search: '',
            //products: null,
            user_key: "",
            productDialog: false,
            deleteProductDialog: false,
            deleteProductsDialog: false,
            lazyParams: {},
            product: {},
            selectedProducts: null,
            filters: {},
            offset: 1,
            selectstatus: { name: "", value: "" },
            // selectstatus2: { name: "Motivational", value: "Motivational" },
            limit: 10,
            columns: [],
            head: [
                "Data Usages",
                "Network Connectivity",
                "Students",
                "Teachers",
                "Student Registration",
                "News Master",
                "Government Panel",
                "Feedback Master",
                "User Queries",
                "Schemes Master",
                "Notice Master",
                "Subject Master",
                "Teacher Schedule Master",
                "Teacher Schedule DE Master",
                "Query Types Master",
                "Sub Query Types Master",
                "Admin Users",
                "Application Roles",
                "Departments",
                "Cast Master",
                "Year Master",
                "District Master",
                "Student Attendance",
                "Student Document",
                "Teachers",
                "Radical ids",
                "Subject Topics",
                "Query Comments",
                "Student Submit Answers",
                "Mock Tests",
                "Mock Test Papers",
                "Mock Test Results",
                "Video",
                "Syllabus",
                "Course",
            ],
            pageno: 1,
            submitted: false,
            totalRecords: 10,
            id: "",
            statuses: [
                { label: "INSTOCK", value: "instock" },
                { label: "LOWSTOCK", value: "lowstock" },
                { label: "OUTOFSTOCK", value: "outofstock" },
            ],
        };
    },
    productService: null,
    async created() {
        this.productService = new ProductService();
        this.user_key = localStorage.getItem("user_key");
        this.initFilters();
        //this.get_client_list();
    },
    async mounted() {
        // this.productService.getProducts().then(data => this.products = data);
        this.id = this.$route.params.id;
        this.lazyParams = {
            first: 0,
            rows: this.limit,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        if (this.totalRecords == 0) {
            //await this.get_count();
        }
        //await this.get_list();
        //alert(this.id);
    },
    watch: {
        async $route() {
            this.products = [];
            this.columns = [];
            this.totalRecords = 0;
            this.id = this.$route.params.id;
            if (this.id) {
                //await this.get_count();
                //this.get_list();
            }
        },
    },
    methods: {
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 32 && (charCode > 65 || charCode < 90)) {
                evt.preventDefault();
            }
        },
        async search(count) {
            count == 2 ? this.client_id_search = '' : '';
            count == 2 ? this.reg_number = '' : '';
            //await this.get_list();
            //await this.get_count();
        },
        get_client_list() {
            var data = { count: false, };
            var promise = apis.getclientist(data);
            promise.then((response) => {
                if (response.data.data) {
                    response.data.data
                        .filter(item => item.client_name)
                        .map(item => this.client_id_dropdown.push({ name: item.client_name, code: item._id }));
                }
            });
        },
        async viewProduct(product) {
            // var data=[product]
            console.log(JSON.stringify(product));
            await localStorage.setItem('saveprofilevehicledata', JSON.stringify(product));
            this.$router.push({ name: "vehicleprofile" });
        },
        async downloadQr() {
            var canvas = await document.getElementById("qrprint");
            var anchor = document.createElement("a");
            anchor.href = canvas.toDataURL("image/png");
            anchor.download = "QrIMAGE.PNG";
            anchor.click();
        },
        async printQr() {
            var dataUrl = await document.getElementById('qrprint').toDataURL(); //attempt to save base64 string to server using this var  
            var windowContent = await '<!DOCTYPE html>';
            windowContent += await '<html>'
            windowContent += await '<head><title>Print canvas</title></head>';
            windowContent += await '<body>'
            windowContent += await '<img src="' + dataUrl + '">';
            windowContent += await '</body>';
            windowContent += await '</html>';
            var printWin = window.open('', '', 'width=900,height=600,align=center');
            // alert(windowContent);
            await printWin.document.open();
            await printWin.document.write(await windowContent);
            printWin.document.close();
            printWin.focus();
            printWin.print();
            // printWin.close();
        },
        //a simple date formatting function
        dateFormat(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == 'NaN-NaN-NaN') {
                    return postdate;
                }
                else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == 'aN') {
                        return postdate;
                    }
                    else {
                        return date + "-" + month + "-" + year;
                    }
                }
            }
            else {
                return "";
            }
        },
        handleFileUpload() {
            this.file_attachment = this.$refs.file_attachment.files[0];
            //alert(this.$refs.file_attachment.files[0].name);
        },
        async onPage(event) {
            this.lazyParams = event;
            this.page_no = event.page + 1;
            this.limit = event.rows;
            // console.log(event);
            //  await this.get_count();
            if (this.totalRecords > 0) {
                this.get_list();
            }
        },
        get_count: function () {
            var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
            var data = {
                // id: localStorage.getItem("id"),
                count: true,
                client_id: client_id,
                registration_number: this.reg_number
            };
            this.loading = true;
            var promise = apis.vehiclelist(data, this.id);
            promise.then((response) => {
                this.loading = false;
                console.log(response);
                this.totalRecords = response.data.data;
                //alert(this.totalRecords);
            });
            console.log(data);
        },
        get_list: function () {
            var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
            var data = {
                // id: localStorage.getItem("id"),
                client_id: client_id,
                limit: this.limit,
                page_no: this.page_no,
                count: false,
                registration_number: this.reg_number
                //client_id: localStorage.getItem("client_id")?localStorage.getItem("client_id"):''
            };
            this.loading = true;
            var promise = apis.vehiclelist(data, this.id);
            promise.then((response) => {
                this.loading = false;
                console.log(response);
                this.products = response.data.data;
                console.log(this.products[0]);
                if (this.columns.length == 0) {
                    if (this.products.length > 0) {
                        this.columns = Object.keys(this.products[0]);
                    }
                }
            });
            console.log(data);
        },
        formatCurrency(value) {
            if (value)
                return value.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                });
            return;
        },
        openNew() {
            this.product = {};
            this.submitted = false;
            // this.productDialog = true;
            this.$router.push({ name: "vehicle_add" });
        },
        hideDialog() {
            this.productDialog = false;
            this.submitted = false;
        },
        async adduser() {
            this.submitted = true;
            if (!this.selectstatus.value) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select Status",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.firsT_NAME) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter First Name",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.middeL_NAME) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Middle Name",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.surname) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter LastName",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.aadhaR_CARD) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Adhar No",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.state) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter State",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.disrtict) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter District",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.taluka) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Taluka",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.citY_VILLAGE) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter city/village",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.pincode) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Pincode",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.address) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter address",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.mobile) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter mobile",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.email) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter email",
                    life: 3000,
                });
                return false;
            }
            //edit
            if (this.product.admiN_ID) {
                var data = {
                    Admin_id: this.product.admiN_ID,
                    firsT_NAME: this.product.firsT_NAME,
                    middeL_NAME: this.product.middeL_NAME,
                    surname: this.product.surname,
                    address: this.product.address,
                    state: this.product.state,
                    disrtict: this.product.disrtict,
                    taluka: this.product.taluka,
                    citY_VILLAGE: this.product.citY_VILLAGE,
                    mobile: parseInt(this.product.mobile),
                    email: this.product.email,
                    pincode: parseInt(this.product.pincode),
                    aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
                    status: this.selectstatus.value,
                    createD_BY: localStorage.getItem("full_name"),
                };
                this.isLoadingModel = true;
                var promise = apis.editusermaster(data);
                promise
                    .then((responseapi) => {
                        this.$swal(responseapi.data.message);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        //this.get_list();
                        //this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data);
                        //this.get_list();
                        //this.get_count();
                    });
            }
            //add-----------------------------------------------------------------------------------------------------------------
            else {
                var data1 = {
                    firsT_NAME: this.product.firsT_NAME,
                    middeL_NAME: this.product.middeL_NAME,
                    surname: this.product.surname,
                    address: this.product.address,
                    state: this.product.state,
                    disrtict: this.product.disrtict,
                    taluka: this.product.taluka,
                    citY_VILLAGE: this.product.citY_VILLAGE,
                    mobile: parseInt(this.product.mobile),
                    email: this.product.email,
                    pincode: parseInt(this.product.pincode),
                    aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
                    status: this.selectstatus.value,
                    createD_BY: localStorage.getItem("full_name"),
                };
                this.isLoadingModel = true;
                var promises = apis.addusermaster(data1);
                promises
                    .then((response) => {
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal(response.data.message);
                        //this.get_list();
                        //this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data);
                        //this.get_list();
                        //this.get_count();
                    });
            }
            this.selectstatus = { name: "", value: "" };
            //  this.selectstatus2={name:"",value:""}
        },
        saveProduct() {
            this.submitted = true;
            if (this.product.name.trim()) {
                if (this.product.id) {
                    this.product.inventoryStatus = this.product.inventoryStatus.value
                        ? this.product.inventoryStatus.value
                        : this.product.inventoryStatus;
                    this.products[this.findIndexById(this.product.id)] = this.product;
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Product Updated",
                        life: 3000,
                    });
                } else {
                    this.product.id = this.createId();
                    this.product.code = this.createId();
                    this.product.image = "product-placeholder.svg";
                    this.product.inventoryStatus = this.product.inventoryStatus
                        ? this.product.inventoryStatus.value
                        : "INSTOCK";
                    this.products.push(this.product);
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Product Created",
                        life: 3000,
                    });
                }
                this.productDialog = false;
                this.product = {};
            }
        },
        async editProduct(product) {
            this.file_attachment = "";
            this.product = { ...product };
            this.productDialog = true;
            this.selectstatus.value = this.product.status;
            this.selectstatus.name = this.product.status;
            await localStorage.setItem('savevehicledata', '');
            await localStorage.setItem('savevehicledata', JSON.stringify(product));
            this.$router.push({ name: "vehicle_edit" });
        },
        confirmDeleteProduct(product) {
            this.product = product;
            this.deleteProductDialog = true;
        },
        showQr(product) {
            this.qrcodevalue = 'vehicle_id-' + product._id;
            this.qrCodetDialog = true;
            // this.product = product;
            // this.deleteProductDialog = true;
        },
        deleteProduct() {
            this.products = this.products.filter((val) => val.id !== this.product.id);
            this.deleteProductDialog = false;
            this.product = {};
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Product Deleted",
                life: 3000,
            });
        },
        deleteuser() {
            if (this.product._id) {
                var data = {
                    id: this.product._id,
                    user_id: localStorage.getItem("id")
                };
                this.isLoadingModel = true;
                var promise = apis.deletevehicle(data);
                promise.then((responseapi) => {
                    this.isLoadingModel = false;
                    if (responseapi.data.status == true) {
                        // this.hideDialog1();
                        this.deleteProductDialog = false;
                        this.$swal(responseapi.data.message);
                        //this.get_list();
                        //this.get_count();
                    } else {
                        this.$swal("error to Delete vehicle");
                    }
                });
            }
        },
        findIndexById(id) {
            let index = -1;
            for (let i = 0; i < this.products.length; i++) {
                if (this.products[i].id === id) {
                    index = i;
                    break;
                }
            }
            return index;
        },
        createId() {
            let id = "";
            var chars =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 5; i++) {
                id += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return id;
        },
        async exportCSV() {
            this.limit = this.totalRecords;
            // this.get_list();
            if (this.columns.length == 0) {
                if (this.products.length > 0) {
                    this.columns = Object.keys(this.products[0]);
                }
            }
            await this.$refs.dt.exportCSV();
        },
        confirmDeleteSelected() {
            this.deleteProductsDialog = true;
        },
        deleteSelectedProducts() {
            this.products = this.products.filter(
                (val) => !this.selectedProducts.includes(val)
            );
            this.deleteProductsDialog = false;
            this.selectedProducts = null;
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Products Deleted",
                life: 3000,
            });
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
    },
    components: { downloadExcel: JsonExcel, QrcodeVue },
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  